
define('template!companiesDetailBodyInfoView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="info-scroll">\n  <form class="info-form" autocomplete="off">\n    <div class="info-section">\n      <div class="info-section-title">' +
((__t = ( _.i18n('companies.info.identity', null, 'Company information') )) == null ? '' : __t) +
'</div>\n      <div class="info-grid">\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.webSite', null, 'Website') )) == null ? '' : __t) +
'</label>\n          <input type="text" class="js-webSite" maxlength="255" value="' +
((__t = ( webSite ? _.escape(webSite) : '' )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.industry', null, 'Industry') )) == null ? '' : __t) +
'</label>\n          <input type="text" class="js-industry" maxlength="255" value="' +
((__t = ( industry ? _.escape(industry) : '' )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.linkedIn', null, 'LinkedIn') )) == null ? '' : __t) +
'</label>\n          <input type="text" class="js-linkedIn" maxlength="255" value="' +
((__t = ( linkedIn ? _.escape(linkedIn) : '' )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.companyPhone', null, 'Company phone') )) == null ? '' : __t) +
'</label>\n          <input type="text" class="js-companyPhone" maxlength="64" value="' +
((__t = ( companyPhone ? _.escape(companyPhone) : '' )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.foundedYear', null, 'Founded year') )) == null ? '' : __t) +
'</label>\n          <input type="number" class="js-foundedYear" min="1800" max="2200" step="1" value="' +
((__t = ( (foundedYear === null || typeof foundedYear === 'undefined') ? '' : foundedYear )) == null ? '' : __t) +
'" />\n        </div>\n      </div>\n    </div>\n\n    <div class="info-section">\n      <div class="info-section-title">' +
((__t = ( _.i18n('companies.info.metrics', null, 'Company metrics') )) == null ? '' : __t) +
'</div>\n      <div class="info-grid">\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.employees', null, 'Employees') )) == null ? '' : __t) +
'</label>\n          <input type="number" class="js-employees" min="0" step="1" value="' +
((__t = ( (employees === null || typeof employees === 'undefined') ? '' : employees )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.annualRevenue', null, 'Annual revenue') )) == null ? '' : __t) +
'</label>\n          <input type="number" class="js-annualRevenue" min="0" step="any" value="' +
((__t = ( (annualRevenue === null || typeof annualRevenue === 'undefined') ? '' : annualRevenue )) == null ? '' : __t) +
'" />\n        </div>\n        <div class="info-field">\n          <label>' +
((__t = ( _.i18n('companies.totalFunding', null, 'Total funding') )) == null ? '' : __t) +
'</label>\n          <input type="number" class="js-totalFunding" min="0" step="any" value="' +
((__t = ( (totalFunding === null || typeof totalFunding === 'undefined') ? '' : totalFunding )) == null ? '' : __t) +
'" />\n        </div>\n      </div>\n    </div>\n\n    <div class="info-actions">\n      <button type="button" class="btn js-save">' +
((__t = ( _.i18n('common.save', null, 'Save') )) == null ? '' : __t) +
'</button>\n    </div>\n  </form>\n</div>\n';

}
return __p
};});

